<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9br2Tf/images/cover.jpg?1708648519307" alt="This image is the cover for the book Stranded in Paradise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stranded in Paradise
      </h1>
      <p class="bookDescription body article font2">
        <p>A funny-but-touching tale about everything that can go wrong...and what makes it all right!</p><p>Tess Nelson is poised to take a well-deserved step up the corporate ladder when it's yanked out from under her. With no job and nothing to fill her days--just a nonrefundable ticket for a trip to Hawaii--Tess decides a tropical vacation is just what she needs. But Tess's journey to paradise is a disaster from the beginning. A sprained ankle at the airport is just the beginning. Then there's the lost contact lens and the lost luggage, the lightning storm at a luau, and the hotel fire. Not to mention the approaching hurricane. And the attractive, annoying young man who keeps crossing her path--and really shaking her up. All Tess wants to do is get her life back under control. But God, it seems, has something else in mind--like opening her heart to everything her life could be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lori Copeland
      </h2>
      
      <p class="authorDescription body article"><P>Lori Copeland is a&#160;bestselling author whose books includde Now and Always, Simple Gifts, Unwrapping Christmas, and Monday Morning Faith, which was a finalist for the 2007 Christy Awards. Lori was inducted into the Springfield Writers Hall of Fame in 2000 and lives in the beautiful Ozarks with her husband and family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?572375e2